module.exports = __webpack_public_path__ + "img/gunship.b73a3899.webp";